import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, Typography, Box } from '@mui/material';

function Example() {
  const items = [
    {
      name: "Ramesh Kumar",
      story: "Local tailor of Janakpuri reaches new buyers through Rozgaar.",
      imageUrl: "https://blog.myntra.com/wp-content/uploads/2020/01/Bangalore-Tailor-1.jpg",
      buttonText: "Explore",
    },
    {
      name: "Sarla Devi",
      story: "Sarla home kitchen now serves the entire city.",
      imageUrl: "https://static1.bigstockphoto.com/9/6/2/large2/269065369.jpg",
      buttonText: "Discover",
    },
  ];

  return (
    <div className="carousel-container">
      <Carousel
        animation="slide"
        navButtonsAlwaysVisible={true}
        indicators={true}
        autoPlay={true}
        interval={5000}
      >
        {items.map((item, i) => (
          <Item key={i} item={item} />
        ))}
      </Carousel>
    </div>
  );
}

function Item(props) {
  return (
    <Paper elevation={3} className="carousel-item p-5">
      <Box display="flex" alignItems="center" justifyContent="center" flexDirection={{ xs: 'column', md: 'row' }}>
        <Box flex={1} display="flex" justifyContent="center">
          <img
            src={props.item.imageUrl}
            alt={props.item.name}
            className="image-class "
            style={{ width: '100%', maxWidth: '500px', height: '300px', maxHeight:'300px', objectFit: 'cover' }}
          />
        </Box>
        <Box flex={1} p={2} display="flex" flexDirection="column" justifyContent="center">
          <Typography variant="h6" gutterBottom>
            {props.item.name}
          </Typography>
          <Typography variant="body1">
            {props.item.story}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default Example;